// @ts-nocheck
import constants from "@store/constants";
import { useCanShowInventory } from "@store/Framework/Store/Context/ContextHooks";
import { BreakpointType, hiddenStyles } from "@store/Themes/common/mixins/common";
import { productLinePropsAlt } from "@store/Themes/common/props/productLine";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useState } from "react";
import { css } from "styled-components";

export interface StoreControlLabel {
    label: string;
}

export interface StoreCheckoutCartLinesHeaderProps {
    controlLabels: StoreControlLabel[];
    extendedStyles?: StoreCheckoutCartLinesHeaderInformationsStyles;
}

type Props = StoreCheckoutCartLinesHeaderProps;

export interface StoreCheckoutCartLinesHeaderInformationsStyles {
    headerCartInfosWrapper?: InjectableCss;
    headerCartInfosGridContainer?: GridContainerProps;
    productInfosGridItem?: GridItemProps;
    productControlsGridItem?: GridItemProps;
    productControlsItem?: InjectableCss;
    productText?: TypographyProps;
}

export const storeCheckoutCartLinesHeaderInformationsStyles: StoreCheckoutCartLinesHeaderInformationsStyles = {
    headerCartInfosGridContainer: {
        gap: 20,
        /* bunzl deleted code */
    },
    headerCartInfosWrapper: {
        css: css`
            padding: 0.75em 0.5em;
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
            background-color: ${getColor("common.accent")};
            color: ${getColor("primary")};
            ${hiddenStyles(BreakpointType.Below, "md")}
        `,
    },
    productInfosGridItem: {
        width: productLinePropsAlt.productGridItem?.width,
    },
    productControlsGridItem: {
        width: productLinePropsAlt.productControlsGridItem?.width,
    },
    /* bunzl custom code start */
    productText: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    productControlsItem: {
        css: css`
            width: 100%;
            color: ${getColor("text.main")};
        `,
        /* bunzl custom code end */
    },
};

const StoreCheckoutCartLinesHeaderInformations: FC<Props> = ({ controlLabels, extendedStyles }) => {
    const [styles] = useState(() => mergeToNew(storeCheckoutCartLinesHeaderInformationsStyles, extendedStyles));

    /* Foundation - Start */
    const canShowInventory = useCanShowInventory();

    if (!canShowInventory) {
        controlLabels = controlLabels.filter(c => c.label !== constants.cartHeaderLabels.availability);
    }
    /* Foundation - End */

    return (
        <StyledWrapper {...styles.headerCartInfosWrapper}>
            <GridContainer {...styles.headerCartInfosGridContainer}>
                <GridItem {...styles.productInfosGridItem}>
                    <Typography {...styles.productText}>{translate("Product")}</Typography>
                </GridItem>
                <GridItem {...styles.productControlsGridItem}>
                    {controlLabels.map(({ label }, index) => {
                        const key = `${label}-${index}`;
                        return (
                            <StyledWrapper key={key} {...styles.productControlsItem}>
                                {label}
                            </StyledWrapper>
                        );
                    })}
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default StoreCheckoutCartLinesHeaderInformations;
